import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CustomSortIcon } from "../../../../../components/DatatableHelpers";
import {
	EssayDraftHistorySummary,
	EssayDraftHistoryTableProps,
	studentFilteredColumns,
} from "../../../shared/progress/essayDraftHistory/TableUtil";

export default function EssayDraftHistoryTable({ data }: EssayDraftHistoryTableProps) {
	const averageIncreaseTemplate = (item: EssayDraftHistorySummary) => {
		const isZero = item.averageIncrease === 0;
		const isPositive = item.averageIncrease > 0;
		return (
			<span className={`${isZero ? "" : isPositive ? "text-green-700" : "text-red-700"}`}>
				{item.averageIncrease}
			</span>
		);
	};

	return (
		<DataTable
			dataKey={"writerId"}
			value={data}
			loading={data == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default mt-4`}>
			{Object.entries(studentFilteredColumns).map(([field, header], index) => (
				<Column
					key={index}
					field={field}
					header={header}
					body={field == "averageIncrease" ? averageIncreaseTemplate : null}
					sortable
					headerClassName="!px-2"
					className="!px-2"
				/>
			))}
		</DataTable>
	);
}
